export const IMMEDIATE_UPGRADE = 'IMMEDIATE_UPGRADE';
export const QUANTITY_ADJUSTMENT_UP_DOWN = 'QUANTITY_ADJUSTMENT_UP_DOWN';
export const TWENTY_EIGHT_THIRTY_FIVE_UPGRADE = 'TWENTY_EIGHT_THIRTY_FIVE_UPGRADE';